import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { PATHS, ROOT_PATHS } from '../../Constants';

export const NavigationHistoryContext = React.createContext<{ path: string, title: string }[]>([]);

interface Props {
  children: React.ReactNode;
}

const NavigationHistoryProvider: React.FC<Props> = ({ children }: Props) => {
  const location = useLocation();
  const [navigationHistory, setNavigationHistory] = React.useState<{ path: string, title: string }[]>([]);
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'TITLE' });

  React.useEffect(() => {
    let currentPageKey: PATHS | null = null;
    let param: string | null = null;

    // removing tailing slashes
    let cleanedPathname = location.pathname;
    if (cleanedPathname.length > 1 && cleanedPathname[cleanedPathname.length - 1] === '/') {
      cleanedPathname = cleanedPathname.slice(0, -1);
    }

    for (const key in ROOT_PATHS) {
      const typedKey = key as PATHS;
      // [GA]: root must be equal for all other path we might want to allow parameters
      if (ROOT_PATHS[typedKey] === ROOT_PATHS.ROOT ? ROOT_PATHS[typedKey] === cleanedPathname : cleanedPathname.indexOf(ROOT_PATHS[typedKey]) === 0) {
        currentPageKey = typedKey;
        param = cleanedPathname.substring(ROOT_PATHS[typedKey].length + 1);
        break;
      }
    }

    if (currentPageKey) {
      document.title = intl.formatMessage({ id: 'PAGE_TITLE_' + currentPageKey }) + (param ? ' - ' + intl.formatMessage({ id: param.toUpperCase() }) : '');
    } else {
      document.title = title;
    }

    if (currentPageKey) {
      switch (currentPageKey) {
        case ROOT_PATHS.LOGIN:
        case ROOT_PATHS.SIGN_UP:
          // [GA]: reset breadcrumb and don't store current
          setNavigationHistory(() => ([]));
          break;

        default:
          // On each location change, update your navigation history

          // ...prevHistory.slice(MAX_HISTORY_NAVIGATION - 2)
          setNavigationHistory((prevHistory) => {
            // if same es previous we will not store it
            const lastItem = prevHistory.length && prevHistory[prevHistory.length - 1];

            if (lastItem && lastItem.path === cleanedPathname) {
              return prevHistory;
            } else {
              // const cutPrevHistory = prevHistory.length > MAX_BREAD_CRUMBS ? prevHistory.splice(0, prevHistory.length - MAX_BREAD_CRUMBS) : prevHistory;
              return [...prevHistory, { path: cleanedPathname, title: intl.formatMessage({ id: 'PAGE_TITLE_' + currentPageKey }) + (param ? '-' + param : '') },];
            }
          });
      };
    }
  }, [intl, title, location, navigationHistory]);

  return (
    <NavigationHistoryContext.Provider value={navigationHistory}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export default NavigationHistoryProvider;